import isEmpty from 'lodash/isEmpty';
import { useTemplateContext } from 'modules/campaigns/editor/context';
import { InAppPrimaryContent } from 'modules/campaigns/editor/types';
import { MESSAGE_FORMAT } from 'modules/graphql';
import { WebLink } from 'ui/theme';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { LightText } from '../Sections.styled';

export const getMessageFormat = (messageFormat: MESSAGE_FORMAT) => {
  if (messageFormat === MESSAGE_FORMAT.Everything) {
    return 'Everything: content, styles, layout, and raw data (HTML & JSON)';
  }
  if (messageFormat === MESSAGE_FORMAT.Json) {
    return 'Raw data (JSON)';
  }

  return 'Content, styles, and layout (HTML)';
};

export const InAppContent = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent = {} } = templateAndContent;
  const { messageFormat, inboxMetadata } = primaryContent as InAppPrimaryContent;
  return (
    <>
      <CampaignFormField labelText="Message format">
        <ReadOnlyField name="messageFormat">
          {getMessageFormat(messageFormat) || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
      {inboxMetadata && (
        <>
          <CampaignFormField labelText="Mobile inbox title">
            <ReadOnlyField name="mobileInboxTitle">
              {inboxMetadata.title || <LightText>Not set</LightText>}
            </ReadOnlyField>
          </CampaignFormField>

          <CampaignFormField labelText="Mobile inbox body">
            <ReadOnlyField name="mobileInboxBody">
              {inboxMetadata.subtitle || <LightText>Not set</LightText>}
            </ReadOnlyField>
          </CampaignFormField>

          <CampaignFormField labelText="Mobile inbox thumbnail URL">
            <ReadOnlyField name="mobileInboxThumbnailURL">
              {!isEmpty(inboxMetadata?.icon) ? (
                <WebLink href={inboxMetadata.icon}>{inboxMetadata.icon}</WebLink>
              ) : (
                <LightText>Not set</LightText>
              )}
            </ReadOnlyField>
          </CampaignFormField>
        </>
      )}
    </>
  );
};
